import html2Canvas from 'html2canvas/dist/html2canvas.js'
import JSPDF from 'jspdf/dist/jspdf.debug.js'
export default{
  install(Vue,options) {
    Vue.prototype.ExportPDF = function (response) {
      let exportDom = document.querySelector(response.el);
      // 获取需要打印的区域，以div为单位，此处使用的是vue的选择器
      // 因为在ie10下，会出现input样式丢失的情况，所以在此处清楚input的标签的边框
      let arrnode = exportDom.querySelectorAll('input')
      for (var i = 0; i < arrnode.length; i++) {
        arrnode[i].style.border = 'hidden'
      }
      // 设置背景色PDF
      exportDom.style.background = '#FFFFFF'
      html2Canvas(exportDom, {
        onrendered: function (canvas) {
          let contentWidth = canvas.width
          let contentHeight = canvas.height
          let pageHeight = contentWidth / 592.28 * 841.89
          let leftHeight = contentHeight
          let position = 0
          let imgWidth = 595.28
          let imgHeight = 592.28 / contentWidth * contentHeight

          let pageData = canvas.toDataURL('image/jpeg', 1.0)

          let PDF = new JSPDF('', 'pt', 'a4')

          if (leftHeight < pageHeight) {
            PDF.addImage(pageData, 'JPEG', 0, 0, imgWidth, imgHeight)
          } else {
            while (leftHeight > 0) {
              PDF.addImage(pageData, 'JPEG', 0, position, imgWidth, imgHeight)
              leftHeight -= pageHeight
              position -= 841.89
              if (leftHeight > 0) {
                PDF.addPage()
              }
            }
          }
          PDF.save(response.fileName+'.pdf')
        }
      })
      html2Canvas()
      exportDom.style.background = ''
      for (var i = 0; i < arrnode.length; i++) {
        arrnode[i].style.border = ''
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/ExportPDF.js